<template>
  <article :id="`chapter-${chapter.id}`" class="story-chapter">
    <p>Chapter {{ chapter.chapterNumber }}<span v-if="chapter.dayLabel"> · {{ chapter.dayLabel }}</span></p>
    <h3>{{ chapter.title }}</h3>
    <strong v-if="chapter.summary">{{ chapter.summary }}</strong>
    <div v-if="chapter.body" class="chapter-body">{{ chapter.body }}</div>
    <EntitySection
      v-if="chapter.entityReferences && chapter.entityReferences.length"
      :items="chapter.entityReferences"
      :entity-by-id="entityById"
      :section-id="`chapter-${chapter.id}-reveals`"
      title="Revealed in this chapter"
      kicker="Places and Experiences"
    />
  </article>
</template>

<script>
import EntitySection from '../entities/EntitySection.vue';

export default {
  name: 'StoryChapter',
  components: { EntitySection },
  props: { chapter: { type: Object, required: true }, entityById: { type: Object, required: true } },
};
</script>

<style scoped>
.story-chapter { border-bottom: 1px solid #2a2a2a; padding: 64px 0; }
.story-chapter > p { color: #e23232; font-family: "Oswald", sans-serif; font-weight: 800; text-transform: uppercase; }
h3 { color: #fff; font-family: "Oswald", sans-serif; font-size: 2.5rem; margin: 0 0 14px; }
.story-chapter > strong { color: #eee; display: block; font-size: 1.2rem; line-height: 1.5; }
.chapter-body { color: #bbb; line-height: 1.8; margin-top: 20px; white-space: pre-line; }
</style>
